import React from 'react';
import one from '../Images/Diet-01.png'
import two from '../Images/Diet-02.png'
import three from '../Images/Diet-03.png'
function DietSection() {
  return (
    <div className="bg-[#f1f3ef] text-[#3f4a2f] font-quicksand py-10 px-4 md:px-16">
      
      <div className="max-w-[1200px] mx-auto text-center">
        <h1 className="text-[40px] font-bold mb-2">
          Diet & Nutrition Counselor
        </h1>
        <div className="flex items-center justify-center mb-8 text-base font-normal">
          <div className="flex-1 border-b border-[#3f4a2f] max-w-[100px]"></div>
          <span className="mx-3 text-[20px] font-medium">(Diabetes & Weight Loss Expert)</span>
          <div className="flex-1 border-b border-[#3f4a2f] max-w-[100px]"></div>
        </div>
        <p className="max-w-[900px] mx-auto mb-12 text-[19px] font- leading-relaxed">
          Customized diets are developed by the top dietitian in Ludhiana to cater to specific individuals or goals. We concentrate exclusively on the specific needs and demands of every person.
        </p>

        {/* Form */}
        <form className="max-w-[900px] mx-auto flex flex-wrap justify-center gap-5 mb-20">
          <input
            type="text"
            placeholder="Name:"
            aria-label="Name"
            className="min-w-[180px] flex-1 px-4 py-3 bg-[#e6e9e9] text-gray-600 border-none rounded-md placeholder-gray-600"
          />
          <input
            type="tel"
            placeholder="Mobile:"
            aria-label="Mobile"
            className="min-w-[180px] flex-1 px-4 py-3 bg-[#e6e9e9] text-gray-600 border-none rounded-md placeholder-gray-600"
          />
          <select
            aria-label="Select Service"
            className="min-w-[180px] flex-1 px-4 py-3 bg-[#e6e9e9] text-gray-600 border-none rounded-md cursor-pointer"
            defaultValue=""
          >
            <option value="" disabled>
              -- Select Service --
            </option>
            <option value="weight-loss">Weight Loss</option>
              <option value="weight-gain">Weight Gain</option>
              <option value="fast-weight-loss">Fast Weight Loss</option>
              <option value="detox-diet">Detox Diet</option>
              <option value="menopause">Menopause</option>
              <option value="gym-diet">Gym Diet</option>
              <option value="fatty-liver">Fatty Liver</option>
              <option value="diabetes-diet">Diabetes Diet</option>
              <option value="pcos-management">PCOS Management</option>
              <option value="cholesterol">Cholesterol</option>
              <option value="ketogenic-diet">Ketogenic Diet</option>
              <option value="depression-cure">Depression Cure</option>
              <option value="thyroid-management">Thyroid Management</option>
              <option value="autoimmune-disorder">Autoimmune Disorder</option>
              <option value="concentration-builder">Concentration Builder</option>
              <option value="glowing-skin">Glowing Skin</option>
              <option value="anemia-diet">Anemia Diet</option>
              <option value="vegan-diet">Vegan Diet</option>
              <option value="hairfall-reduction">Hairfall Reduction</option>
              <option value="gluten-free-diet">Gluten Free Diet</option>
              <option value="high-uric-acid-diet">High Uric Acid Diet</option>
              <option value="post-pre-pregnancy">Post & Pre Pregnancy</option>
              <option value="kids-diet">Kids Diet</option>
              <option value="sports-diet">Sports Diet</option>
              <option value="blood-pressure-diet">Blood Pressure Diet</option>
              <option value="nutrition-in-cancer">Nutrition in Cancer</option>
              <option value="kidney-disease-management">Kidney Disease Management</option>
              <option value="epilepsy-diet-therapy">Epilepsy Diet Therapy</option>

          </select>
          <button
            type="submit"
            className="min-w-[140px] flex-shrink-0 px-8 py-3 bg-[#4a5333] text-white font-medium rounded-md cursor-pointer"
          >
            SUBMIT
          </button>
        </form>

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-10">
          {/* Card 1 */}
          <div className="bg-[#e1e7c7] max-w-[320px] flex flex-col items-center text-center p-5 ">
            <img
              src={one}
              alt="Person showing nutrition chart to client in office setting"
              className="w-[280px] h-[180px] object-cover mb-5"
            />
            <h3 className=" font-bold mb-3 text-[25px]">Personalized Nutrition</h3>
            <p className="text-[17px] font-normal mb-5">
              Individualized nutrition and its positive impacts (boosted health & energy levels, fitness milestones, warding off diseases).
            </p>
            <div className="text-[4.5rem] font-light text-[#4a5333] mt-auto">01</div>
          </div>

          {/* Card 2 */}
          <div className="bg-[#e1e7c7] max-w-[320px] flex flex-col items-center text-center p-5 ">
            <img
              src={two}
              alt="Person with healthy food and clock showing time for diet"
              className="w-[280px] h-[180px] object-cover mb-5"
            />
            <h3 className="font-bold mb-3 text-[25px]">Health Diet Programs</h3>
            <p className="text-[17px] font-normal mb-5">
              Explore the best nutritional programs available to support your journey towards weight reduction and overall wellness.
            </p>
            <div className="text-[4.5rem] font-light text-[#4a5333] mt-auto">02</div>
          </div>

          {/* Card 3 */}
          <div className="bg-[#e1e7c7] max-w-[320px] flex flex-col items-center text-center p-5 ">
            <img
              src={three}
              alt="Woman holding fork with vegetable and salad bowl, smiling"
              className="w-[280px] h-[180px] object-cover mb-5"
            />
            <h3 className="font-bold mb-3 text-[25px]">Weight Loss Program</h3>
            <p className="text-[17px] font-normal mb-5">
              Weight loss plan designed to guide you toward your objectives and promote a healthier way of living.
            </p>
            <div className="text-[4.5rem] font-light text-[#4a5333] mt-auto">03</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DietSection;
